import React from 'react';
import './App.css';

import PokemonOfTheDay from './PokemonOfTheDay'
import BusTime from './BusTime'


function App() {
  return (
    <>
      <br/>
      <BusTime />
      <PokemonOfTheDay />
    </>
  );
}

export default App;
